import { ApiCalls } from "@/assets/libs/services"
import { app } from "@/main"
import { isDefinedString } from "@/assets/libs/utils"

function _referrer (referrer) {
  if (referrer.includes("asirindo")) {
    return "asirindo"
  } else if (referrer.includes("rias")) {
    return "mrss"
  } else if (referrer.includes("phonorights")) {
    return "pnr"
  } else if (referrer.includes("pplindia")) {
    return "pplindia"
  } else {
    return ""
  }
}

const state = {
  society: null,
  societies: [],
  language: {},
  languages: [],
  memberDetail: {},
  members: [],
}

const getters = {
  editMembers: state => {
    return state.member_detail_id !== null
  },
  societyRef: state => {
    /* with the hostname from the referrer we can get the
    society that is being used */
    return _referrer(state.referrer)
  },
  logoSrc: state => {
    let val = state.society

    if (isDefinedString(val)) {
      let aux = state.societies.filter(x => x.name === val)
      return aux[0].logo
    } else {
      return ""
    }
  },
  currentSocietyName: state => {
    let val = state.society

    if (isDefinedString(val)) {
      return state.societies.filter(x => x.name === val)[0].name
    } else {
      return ""
    }
  },
}

const mutations = {
  setSocieties (state, value) {
    state.societies = value
  },
  setReferrer (state, value) {
    state.referrer = value
  },
  setSociety (state, value) {
    state.society = value
  },
  setLanguage (state, value) {
    state.language = value
  },
  setLanguages (state, value) {
    state.languages = value
  },
  setSocietyFromReferrer (state, referrer) {
    /* with the hostname from the referrer we can gest the
      society that is been used */
    state.society = _referrer(referrer)
  },
  setMemberDetail (state, value) {
    state.memberDetail = value
  },
  setMembers (state, value) {
    state.members = value
  }
}

const actions = {
  getMemberData ({ commit }, userID) {
    return ApiCalls.getMember(userID).then(x => {
      commit("setMemberDetail", x.data)
    })
  },
  saveMemberData ({ commit }, memberId) {
    ApiCalls.setMember(memberId).then(x => {
      commit("setMemberDetail", x.data)
    })
  },
  getSocieties ({ commit }) {
    ApiCalls.getSocieties().then(x => {
      commit("setSocieties", x)
    })
  },
  getMembers ({ commit }) {
    return ApiCalls.getMembers().then(x => {
      commit("setMembers", x)
    })
  },
  getLanguages ({ state, commit }, societies=null) {
    let society_names = []
    if (societies) {
      society_names = societies.map(society => society.name)
    } else {
      if (!isDefinedString(state.society)) return
      society_names = state.society
    }
    ApiCalls.getMemberLanguages(society_names)
      .then(response => commit("setLanguages", response))
  },
  setLanguage ({ commit }, payload) {
    let { post, language = payload } = payload
    // Language must be an object with a valid alpha_2 key
    if (post) ApiCalls.setUserLang(language.alpha_2)

    commit("setLanguage", language)
    app.$i18n.locale = language.alpha_2
    localStorage.setItem("lang", language.alpha_2)
  },
  resetLanguages ({ commit }) {
    commit("setLanguages", [])
    commit("setLanguage", { name: "English", alpha_2: "en" })
    if (app) app.$i18n.locale = "en"
    localStorage.setItem("lang", "en")
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
